/* 顶部菜单右侧-账号管理菜单相关 */
import {
  getBindphoneUrl as _getBindphoneUrl,
  getBindEmailUrl as _getBindEmailUrl,
  getResetPasswordUrl as _getResetPasswordUrl,
  getEpassportLoginUrl as _getEpassportLoginUrl,
} from "@osgfe/tools";

const nodeEnv = process.env.NODE_ENV;
const IS_DEV = nodeEnv === "development";

const CUSTOM_PARAMS = {
  service: "com.sankuai.osgfe.jiemo.server",
  feconfig: "com.sankuai.osgvss.w",
};

export function getBindphoneUrl() {
  return _getBindphoneUrl(CUSTOM_PARAMS);
}

export function getBindEmailUrl() {
  return _getBindEmailUrl(CUSTOM_PARAMS);
}

export function getResetPasswordUrl() {
  return _getResetPasswordUrl(CUSTOM_PARAMS);
}

export function getLoginUrl() {
  return _getEpassportLoginUrl(CUSTOM_PARAMS);
}

export function redirectLoginUrl() {
  if (IS_DEV) {
    window.location.href = getLoginUrl();
  } else {
    window.location.href = `${window.location.origin}/login.html`;
  }
}